import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="grid min-h-screen place-items-center bg-[#0B0F17] text-slate-400">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
